import type { TrialMasterStore } from '@fitness-force/models';
export const TRIAL_MASTER_STATE: TrialMasterStore ={
    trials: []
}